import { OrderUtils } from './order.utils';

export class OrderValidation extends OrderUtils {
  /**
   * @param {any} submit - HTMLElement or ClassName
   * @param {HTMLFormElement} form
   * @returns {OrderFormBySteps}
   */
  validateForm(form, submit) {
    const submitButton = typeof submit === 'string' ? form.querySelector(submit) : submit;
    if (submitButton !== null) {
      submitButton.addEventListener('click', (event) => {
        form.classList.add('was-validated');
        const invalidTab = this.order.querySelector('.invalid');
        if (!form.checkValidity()) {
          event.stopPropagation();
        }

        if (!form.checkValidity() && invalidTab === null) {
          event.stopPropagation();
          form.classList.remove('valid');
        } else if (form.checkValidity()
          && invalidTab !== null
          && invalidTab.dataset.step < this.TAB_STATES.step) {
          if (!this.debug) {
            event.stopPropagation();
            $(invalidTab).find('.card-header button').click();
          }
          form.classList.add('valid');
        } else {
          form.classList.add('valid');
        }
      });
    }
    return this;
  }

  activateNextStep() {
    this.TAB_STATES.verifiedStepsCount = this.order.querySelectorAll('form:valid').length;

    if (this.TAB_STATES.step !== this.TAB_STATES.lastStep + 1) {
      this.order.querySelector(`[data-step="${this.TAB_STATES.step + 1}"]`)?.classList.remove('disabled');
      this.order.querySelector(`[data-step="${this.TAB_STATES.step + 1}"]`)?.classList.add('valid');

      this.order.querySelector(`[data-step="${this.TAB_STATES.step}"]`)?.classList.remove('disabled');
      this.order.querySelector(`[data-step="${this.TAB_STATES.step}"]`)?.classList.add('valid');
      this.TABS[this.TAB_STATES.step - 1].disabled = false;
    }
    return this;
  }

  /** @param {Element} tab */
  checkValidStepForm(tabs) {
    Array.prototype.filter.call(tabs, (tab) => {
      const invalidSelector = 'input:invalid:not(:disabled), select:invalid:not(:disabled), textarea:invalid:not(:disabled)';
      const findInvalidEl = tab.querySelector('form').querySelector(invalidSelector);
      if (!tab.classList.contains('skip')) {
        if (findInvalidEl === null) {
          tab.classList.remove('invalid');
          tab.classList.add('valid');
          this.TABS[tab.dataset.step - 1].invalid = false;
          this.TABS[tab.dataset.step - 1].valid = true;
        } else {
          tab.classList.remove('valid');
          tab.classList.add('invalid');
          this.TABS[tab.dataset.step - 1].invalid = true;
        }
      }
    });
    return this;
  }

  disableNonPassedStep() {
    for (let i = this.TAB_STATES.lastStep; i > this.TAB_STATES.opened; i -= 1) {
      this.order.querySelector(`[data-step="${i}"]`).classList.add('disabled');
      this.TABS[i - 1].disabled = true;
    }
    return this;
  }

  async onFormChange() {
    const formElements = this.order.querySelectorAll('input');
    [...formElements].forEach((el) => {
      if (!this.debug) {
        const modal = document.querySelector('#modalMap');
        this.checkValidStepForm(this.order.querySelectorAll('[data-step]:not(.disabled)'));

        $(modal).on('hidden.bs.modal', () => {
          this.checkValidStepForm(this.order.querySelectorAll('[data-step]:not(.disabled)'));
        });
      }
      el.addEventListener('change', () => {
        if (!this.debug) this.checkValidStepForm(this.order.querySelectorAll('[data-step]:not(.disabled)'));
      });
    });
  }
}
